/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, ButtonBase, Card, CircularProgress, Container, Dialog, Divider, FormControl, FormHelperText, IconButton, InputAdornment, InputBase, Typography } from '@mui/material';
import { useAppDispatch } from 'app/hooks';
import React, { Fragment, useState, useEffect } from 'react';
import { _Tokens, GasFeeInterface } from '../../types';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { changePopupStep, clearReceiptState, popupSelector, setReceiptValue, setUpdate } from './popupSlice';
import { useAppSelector } from '../../app/hooks';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { FERNET_KEY, walletStepEnum } from '../../libs/constans';
import { minimizeAddress } from 'libs/utils';
import { userSelector } from '../user/userSlice';
import ApiSingWallet from '../../libs/apiSingWallet';
import fernet from 'fernet';

export default function TransactionToken() {

    const { step, token } = useAppSelector(popupSelector);

    if (!token) {
        return <></>
    }

    return (
        <Fragment>
            {step === walletStepEnum.SEND_TOKEN &&
                <>
                    <WalletNav title="Transaction Token" />
                    <Transaction token={token} />
                </>
            }
            {step === walletStepEnum.SEND_TOKEN_CONFIRM &&
                <>
                    <WalletNav title="Transaction Token" />
                    <TransactionConfirm token={token} />
                </>
            }
        </Fragment>
    );
}

const btn_styles = {
    width: '100%',
    background: '#33394F',
    boxShadow: `0px 4px 15px rgba(0, 0, 0, 0.5)`,
    borderRadius: '24px',
    padding: '14px 24px',
    display: 'flex',
    justifyContent: 'center',
    alignTtems: 'center',
} as const;

export type ReceiptProps = {
    reception_address: string,
    amount: number
}

export function Transaction({ token }: { token: _Tokens }) {

    const dispatch = useAppDispatch();
    const { ratio } = useAppSelector(popupSelector)

    const [receipt, setReceipt] = useState<ReceiptProps>({
        reception_address: "",
        amount: 0.0
    })
    const [error, setError] = useState(" ");

    const handleClick = () => {
        if (receipt.reception_address === "") {
            setError("Address cannot be empty");
            return;
        }
        if (receipt.amount === 0) {
            setError(`Not enough balance to send`);
            return;
        }
        if (receipt.amount > Number(token.balance)) {
            setError(`Balance is not enough`);
            return;
        }
        dispatch(setReceiptValue(receipt));
        dispatch(changePopupStep(walletStepEnum.SEND_TOKEN_CONFIRM));

    }

    const handleAddressChange = (e: any) => {
        setReceipt(prevState =>
        ({
            ...prevState,
            reception_address: e.target.value
        })
        )
    }

    const handleAmountChange = (e: any) => {
        const value = e.target.value ? parseFloat(e.target.value) : 0
        if (value >= 0) {
            setReceipt(prevState =>
            ({
                ...prevState,
                amount: value
            })
            )
        }
    }

    const handleMaxChange = () => {
        setReceipt(prevState =>
        ({
            ...prevState,
            amount: parseFloat(token.balance)
        })
        )
    }

    const amountUSDTString = (parseFloat(token.balance) * ratio[token.symbol]).toFixed(2);

    return (
        <Fragment>
            <Box>
                <Box p={1} sx={{ mb: 2 }}>
                    <Typography sx={{ mb: 1, color: '#B1BBD2' }}>Recipion Address</Typography>
                    <FormControl fullWidth variant="outlined">
                        <InputBase
                            value={receipt.reception_address}
                            onChange={handleAddressChange}
                            sx={{ borderRadius: '8px', border: 'solid 1px #413D3D', p: 1 }}

                            endAdornment={<InputAdornment position="end"><QrCodeScannerIcon /></InputAdornment>}

                        />
                    </FormControl>
                </Box>

                <Box p={1} sx={{ mb: 1 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography sx={{ mb: 1, color: '#B1BBD2' }}>Amount&nbsp;{token.symbol}</Typography>
                        <Typography sx={{ mb: 1 }}>{token.balance}&nbsp;{token.symbol}&nbsp;(${amountUSDTString})</Typography>
                    </Box>

                    <FormControl fullWidth variant="outlined">
                        <InputBase
                            value={receipt.amount}
                            onChange={handleAmountChange}
                            type="number"
                            sx={{ borderRadius: '8px', border: 'solid 1px #413D3D', p: 1 }}

                            endAdornment={<InputAdornment position="end"><Typography onClick={handleMaxChange} sx={{ color: '#D68DDE', cursor: 'pointer' }}>MAX</Typography></InputAdornment>}

                        />
                    </FormControl>
                </Box>
                <Box p={1} sx={{ mb: 2 }}>
                    <Typography sx={{ mb: 1 }}>~${(ratio[token.symbol] * receipt.amount).toFixed(2)}</Typography>
                </Box>
            </Box>
            <Box p={2}>
                <FormHelperText sx={{ color: '#B1BBD2' }}>{error}</FormHelperText>
            </Box>
            <Box sx={{ p: 3, position: 'absolute', left: '0px', bottom: '20px', width: '100%' }}>
                <Container fixed maxWidth='sm'>
                    <Box sx={{ mx: 3 }}>
                        <ButtonBase sx={btn_styles} onClick={handleClick}>NEXT</ButtonBase>
                    </Box>
                </Container>
            </Box>
        </Fragment>
    );
}

const card_styles = {
    position: 'absolute',
    zIndex: -1,
    textAlign: 'center',
    p: 2,
    background: `linear-gradient(90deg, #BF26E6 -5.41%, #3C14DA 100%)`,
    width: '100%',
    left: 0,
} as const;

const card_styles2 = {
    backgroundColor: '#242A3E',
    boxShadow: `0px 4px 4px rgba(0, 0, 0, 0.25)`,
    borderRadius: `20px`,
    padding: '16px',
    marginLeft: '5px',
    marginRight: '5px',
    marginBottom: '17px',
} as const;

const btn_styles2 = {
    width: '100%',
    background: `linear-gradient(90deg, #BF26E6 -5.41%, #3C14DA 100%)`,
    boxShadow: `0px 4px 15px rgba(0, 0, 0, 0.5)`,
    borderRadius: '24px',
    padding: '14px 24px',
    display: 'flex',
    justifyContent: 'center',
    alignTtems: 'center',
} as const;

export function TransactionConfirm({ token }: { token: _Tokens }) {

    const [error, setError] = useState(" ");
    const api = new ApiSingWallet();
    const dispatch = useAppDispatch();

    const { wallet, ratio, receiptValue } = useAppSelector(popupSelector);
    const { user, tokenBearer } = useAppSelector(userSelector);

    const [pending, setPending] = useState(false);
    const [gasFee, setGasFee] = useState<GasFeeInterface>()

    const [open, setOpen] = useState(false)

    const getGasFee = async (price, walletId) => {
        setPending(true);
        await api.getGasFee(price, walletId, tokenBearer).then(
            (result) => {
                setGasFee(result)
            },
            (error) => {
                console.log(error!.message)
                setError(error!.message)
            }
        )
        setPending(false);
    }

    useEffect(() => {
        if (!pending) {
            getGasFee(receiptValue.amount, token.walletId)
        }
    }, [user, token])

    const [isLoading, setLoading] = useState(false);

    const handleClick = async () => {
        setLoading(true)
        var tk = {
            token_contract: token.tokenAddress ? token.tokenAddress : "",
            token_amount: receiptValue.amount,
            receiver_address: receiptValue.reception_address,
        }
        var secret = new fernet.Secret(FERNET_KEY);
        var encrypted = new fernet.Token({
            secret: secret,
        })
        encrypted.encode(JSON.stringify(tk));

        await api.sendTokens(token.walletId, encrypted.token, tokenBearer).then(
            (result) => {
                console.log(result);
                setError(" ");
                dispatch(setUpdate());
                setOpen(true)
            },
            (error) => {
                console.log(error!.message);
                setError(error!.message);
            }
        )

        setLoading(false)

    }

    const handleClose = () => {
        setError(" ");
        dispatch(clearReceiptState());
        setOpen(false)
        dispatch(setUpdate())
        dispatch(changePopupStep(walletStepEnum.WALLET_DETAILS))
    }

    const amountUSDTString = (parseFloat(token.balance) * ratio[token.symbol]).toFixed(2);

    return (
        <Fragment>
                <Card sx={card_styles}>
                    <Box>
                        <Typography sx={{ fontSize: '42px', fontWeight: 500 }}>{`$`}{amountUSDTString}</Typography>
                    </Box>
                    <Box sx={{ mb: 4 }}>
                        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>{token.balance}&nbsp;{token.symbol}</Typography>
                    </Box>
                </Card>

                <Box sx={{ marginTop: '140px' }}></Box>

                <Card sx={card_styles2}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, mt: 2 }}>
                        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>{`From`}</Typography>
                        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>{`Promotion  (${minimizeAddress(wallet?.address)})`}</Typography>
                    </Box>
                    <Divider />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, mt: 2 }}>
                        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>{`Asset`}</Typography>
                        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>{`Smart Chain  (BSC)`}</Typography>
                    </Box>
                    <Divider />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, mt: 2 }}>
                        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>{`To`}</Typography>
                        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>{minimizeAddress(receiptValue.reception_address, 10)}</Typography>
                    </Box>

                </Card>

                <Card sx={card_styles2}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, mt: 2 }}>
                        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>{`Network Fee *`}</Typography>
                        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>{pending ? `loading...` : `${(gasFee ? gasFee.gas_fee_native : 0).toFixed(6)}${gasFee?.native_symbol} ≈ $${(gasFee ? gasFee.gas_fee_usd : 0)?.toFixed(6)}`}</Typography>
                    </Box>
                    <Divider />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, mt: 2 }}>
                        <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>{`Total`}</Typography>
                        <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>{((gasFee ? gasFee?.gas_fee_native : 0) + receiptValue.amount).toFixed(6)}&nbsp;{gasFee?.native_symbol}</Typography>
                    </Box>

                </Card>

                <Box p={2}>
                    <FormHelperText sx={{ color: '#B1BBD2' }}>{error}</FormHelperText>
                </Box>
                <Box sx={{ p: 3, position: 'absolute', left: '0px', bottom: '20px', width: '100%' }}>
                    <Container fixed maxWidth='sm'>
                        <Box sx={{ mx: 3 }}>
                            <ButtonBase sx={btn_styles2} onClick={handleClick} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={20} /> : `CONFIRM`}
                            </ButtonBase>
                        </Box>
                    </Container>
                </Box>
                <Dialog open={open}>
                    <Card>
                        <Box p={2}>
                            <Typography>Transaction success</Typography>
                        </Box>
                        <Box m={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Button onClick={handleClose} variant="contained">Back</Button>
                        </Box>
                    </Card>
                </Dialog>
        </Fragment>
    );
}

export function TransactionResult({ token }: { token: _Tokens }) {

    return (
        <Fragment>

        </Fragment>
    );
}

export function WalletNav({ title }: { title: string }) {
    const dispatch = useAppDispatch()
    const { step, prevStep } = useAppSelector(popupSelector);

    const handleBack = () => {
        if (step === walletStepEnum.SEND_TOKEN)
            dispatch(changePopupStep(prevStep))
        else
            dispatch(changePopupStep(step - 1))
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
            <IconButton onClick={handleBack}>
                <KeyboardBackspaceIcon />
            </IconButton>
            <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{title}</Typography>
            <IconButton>

            </IconButton>
        </Box>
    );
}